<div class="row align-center" [formGroup]="form">
  <div [class]="columnClass" (click)="handleTouch('label')">
    <mat-label class="d-block">{{'Inputs.Name' | translate}}</mat-label>
    <mat-form-field class="d-block w-100" appearance="outline">
      <input type="text" matInput formControlName="label"/>
      <ng-content select="label-error"></ng-content>
    </mat-form-field>
  </div>
  <div [class]="columnClass" (click)="handleTouch('receiver')">
    <div class="mb-6">
      <app-dropdown
        [title]="'Inputs.Receiver' | translate"
        [list]="receivers"
        formControlName="receiver">
      </app-dropdown>
      <ng-content select="receiver-error"></ng-content>
    </div>
  </div>
  <div [class]="columnClass" (click)="handleTouch('expirationDate')">
    <app-date-input
      formControlName="expirationDate"
      [title]="'Inputs.expirationDate' | translate"
      [min]="minDate"
      [required]="false"
    ></app-date-input>
    <ng-content select="expirationDate-error"></ng-content>
  </div>

  <div class="col-12">
    <ng-content></ng-content>
  </div>
</div>
